/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S4_HeadingInputs */

const tr_mesafeli_s4_heading = /** @type {(inputs: Mesafeli_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Sözleşmenin Kurulması`)
};

const en_mesafeli_s4_heading = /** @type {(inputs: Mesafeli_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Formation of the Agreement`)
};

const de_mesafeli_s4_heading = /** @type {(inputs: Mesafeli_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Zustandekommen des Vertrages`)
};

const ru_mesafeli_s4_heading = /** @type {(inputs: Mesafeli_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Заключение Договора`)
};

/**
* | output |
* | --- |
* | "4. Formation of the Agreement" |
*
* @param {Mesafeli_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s4_heading = /** @type {((inputs?: Mesafeli_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s4_heading(inputs)
	if (locale === "de") return de_mesafeli_s4_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s4_heading(inputs)
	return tr_mesafeli_s4_heading(inputs)
});